import React from 'react';
import ModuleShell from '@/components/layout/ModuleShell';
import PoliciesPage from '@/pages/PoliciesPage';
import FamilyRegisterPage from '@/pages/FamilyRegisterPage';

export default function PoliciesModule() {
  const tabs = [
    { id: 'register', label: 'Register', content: <PoliciesPage /> },
    { id: 'families', label: 'Families', content: <FamilyRegisterPage /> },
  ];

  return (
    <ModuleShell title="Policies" subtitle="System of record" tabs={tabs} />
  );
}
